import { Component, Input } from '@angular/core';
import { EditorType, SuboptionTypeDescriptions } from '../../lib/client-configuration';
import { ClientConfigurationOptionDefinition } from '../../../core/models/client-configuration-option-definition.model';
import { ClientConfigurationOption } from '../../../core/models/client-configuration-option.model';
import { NgClass, DatePipe } from '@angular/common';

@Component({
    selector: 'app-client-configuration-title',
    templateUrl: './client-configuration-title.component.html',
    styleUrls: ['./client-configuration-title.component.scss'],
    imports: [NgClass, DatePipe]
})
export class ClientConfigurationTitleComponent {
  @Input() editorType: EditorType;
  @Input() deactivated: boolean;
  @Input() definition: ClientConfigurationOptionDefinition;
  @Input() configOption: ClientConfigurationOption;

  editorTypes = EditorType;
  suboptionTypeDescriptions = SuboptionTypeDescriptions;

  constructor() {}
}
